// Collector's Closet PDP helpers (sections/main-product-collectors.liquid).
//
// 1. Gallery: every media item is stacked in a static column on desktop (CSS
//    neutralises the Swiper markup); below 751px a one-slide Swiper takes over
//    so the shopper swipes through images with a thin scrollbar.
// 2. Wishlist: Vitals injects its PDP button wherever it decides; keep moving it
//    into the [Buy now | heart] row (same approach as sections/main-product.liquid).
(function () {
  var MOBILE = '(max-width: 750px)';
  var mq = window.matchMedia(MOBILE);
  var gallerySwiper = null;

  function syncGallery() {
    var el = document.querySelector('[data-cc-gallery]');
    if (!el || typeof Swiper === 'undefined') return;
    var slides = el.querySelectorAll('.swiper-slide').length;

    if (mq.matches && !gallerySwiper && slides > 1) {
      gallerySwiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        watchOverflow: true,
        scrollbar: {
          el: el.querySelector('.swiper-scrollbar'),
          draggable: true,
          hide: false,
          snapOnRelease: true,
          dragSize: 'auto'
        }
      });
    } else if (!mq.matches && gallerySwiper) {
      gallerySwiper.destroy(true, true);
      gallerySwiper = null;
    }
  }

  function relocateWishlist() {
    var row = document.querySelector('.cc-buy-row');
    if (!row) return;
    document.querySelectorAll('.Vtl-WishlistButtonWrapper').forEach(function (wrapper) {
      // Only the PDP text-button variant — card overlays use
      // .Vtl-WishlistButton__WishlistIconButton and must stay put.
      if (!wrapper.querySelector('.Vtl-WishlistButton__AddToWishlist')) return;
      if (wrapper.closest('.collection-product-card, .product-recommendations__product')) return;
      if (!row.contains(wrapper)) row.appendChild(wrapper);
    });
  }

  function init() {
    syncGallery();
    relocateWishlist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', syncGallery);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(syncGallery);
  }
  document.addEventListener('shopify:section:load', init);

  new MutationObserver(relocateWishlist).observe(document.body, {
    childList: true,
    subtree: true
  });
})();
